import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'ggc-lang';

/** localStorage에서 저장된 언어를 가져오거나 기본값 'en' 반환 */
function getStoredLanguage(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'en';
  } catch {
    return 'en';
  }
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: {} },
    ko: { translation: {} },
  },
  lng: getStoredLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

/** 언어 변경 시 localStorage에도 저장 */
export function changeLanguage(lng: 'en' | 'ko') {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch { /* SSR 등 localStorage 미지원 환경 대비 */ }
  return i18n.changeLanguage(lng);
}

/** 현재 설정된 언어 반환 */
export function getCurrentLanguage(): 'en' | 'ko' {
  return (i18n.language as 'en' | 'ko') || 'en';
}

export default i18n;
